<template>
    <div>
        <div class="right fr">
            <button class="swb-btn swb-btn-link" @click="goBack()"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
        </div>
        <div class="mb30">
            <div class="form-single">
                <div class="title">询价标题</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.inqryTitle}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">被询价方</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.merchantName}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">报价时间</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.replyTime}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">要求交付期</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.inqryDeliverPeriod}}&nbsp;&nbsp;天</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">交付期</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.deliverPeriod}}&nbsp;&nbsp;天</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系人</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.contactName}}</div>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系电话</div>
                <div class="content">
                    <div class="">{{priceReplyInfo.contactTel}}</div>
                </div>
            </div>
            <div class="form-single" v-if="priceReplyInfo.goodsFlag==true">
                <div class="title">报价商品</div>
                <div class="content">
                    <div class="table-layout">
                        <el-table :data="priceReplyInfo.goodsList" border style="width: 100%;">
                            <el-table-column prop="goodsImage" width="100" label="商品图片" align="center">
                                <template slot-scope="rows">
                                    <img :src="rows.row.goodsImage"/>
                                </template>
                                <!--<template slot-scope="rows">-->
                                <!--<img src="rows.row.goodsImage"/>-->
                                <!--</template>-->
                            </el-table-column>
                            <el-table-column prop="name" label="商品名称" align="left"></el-table-column>
                            <el-table-column prop="wrntPeriod" label="质保期(月)" width="80" align="center"></el-table-column>
                            <el-table-column prop="quantity" label="数量" width="80" align="center"></el-table-column>
                            <el-table-column prop="unit" label="单位" width="60" align="center"></el-table-column>
                            <el-table-column prop="price" label="市场单价(元)" width="100" align="right">
                                <template slot-scope="rows">
                                    <span v-if="rows.row.price != null && rows.row.price > 0">{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                    <span v-else>面议</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="total" label="市场价小计(元)" width="110" align="right">
                                <template slot-scope="rows">
                                    <span v-if="rows.row.price != null && rows.row.price > 0">{{(parseFloat(rows.row.price) * parseFloat(rows.row.quantity)).toFixed(2)}}</span>
                                    <span v-else>面议</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="replyPrice" label="呈报价格(元)" width="100" align="right">
                                <template slot-scope="rows">
                                    <span>{{parseFloat(rows.row.replyPrice).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="replyWrntPeriod" label="呈报质保期(月)" width="110" align="center"></el-table-column>
                            <el-table-column prop="total" label="报价小计(元)" width="100" align="right">
                                <template slot-scope="rows">
                                    <span>{{(parseFloat(rows.row.replyPrice) * parseFloat(rows.row.quantity)).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <div class="form-single" v-if="priceReplyInfo.servcFlag==true">
                <div class="title">报价服务</div>
                <div class="content">
                    <div class="table-layout">
                        <el-table :data="priceReplyInfo.servcList" border style="width: 100%;">
                            <el-table-column prop="servcImage" width="150" label="服务图片" align="center">
                                <template slot-scope="rows">
                                    <img :src="rows.row.servcImage"/>
                                </template>
                                <!--<template slot-scope="rows">-->
                                <!--<img src="rows.row.servcImage"/>-->
                                <!--</template>-->
                            </el-table-column>
                            <el-table-column prop="name" label="服务名称" width="" align="center"></el-table-column>
                            <el-table-column prop="price" label="市场单价(元)" width="150" align="center">
                                <template slot-scope="rows">
                                    <span>{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="replyPrice" label="呈报价格(元)" width="150" align="center">
                                <template slot-scope="rows">
                                    <span>{{parseFloat(rows.row.replyPrice).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>


            <div class="form-single">
                <div class="title">交易规则</div>
                <div class="content">
                    <swb-create-trade-rule v-if="forGoods != null || forServc != null" :comparedTradeRuleList="comparedTradeRuleList" :type="tradeType" :operate="tradeOperate" :forPriceInqry="forPriceInqry" :forGoods="forGoods" :forServc="forServc" ref="swb_create_trade_rule"></swb-create-trade-rule>
                </div>
            </div>
        </div>
        <div class="form-toolbar align-center" style="padding: 0;" v-if="adopted">
            <button class="swb-btn swb-btn-small" v-if="priceReplyInfo.adopted==false && (isView == false || isView == 'false')" @click="adoptedPrice()">
                <span>采纳</span>
            </button>
            <button class="swb-btn swb-btn-small" v-if="priceReplyInfo.adopted==true">已采纳</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import priceApi from '../../api/price'

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);

    import SwbPriceInpryList from './PriceInpryList';
    Routes.add(SwbPriceInpryList);

    export default{
        name: 'swb-price-reply-info',
        path: '/view/price/reply/detail',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '报价单详情',
        data: function () {
            return {
                priceReplyInfo: {},
                type: 'priceInpry',
                id: null,
                radio: null,
                tableData: null,

                comparedTradeRuleList: [],
                tradeType: 'priceReply',
                tradeOperate: 'chakan',
                forPriceInqry: true,
                forGoods: null,
                forServc: null,
                adopted: null,
                isView: true
            }
        },
        created: function () {
            let self = this;
            let id = this.$route.query.id;
            self.adopted = this.$route.query.adopted;
            self.isView = this.$route.query.isView;
            self.id = id;
            self.getPriceReplyInfo();
        },
        methods: {
            goBack: function () {
                this.$router.back(-1)
            },
            // 获取询价信息
            getPriceReplyInfo: function () {
                let self = this;
                let id = this.$route.query.id;
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceReplyVoucherInfo(id, function (result) {
                    if(result.type == 'info') {
                        let data = result.data;
                        // console.log("=====返回data====" + JSON.encode(data));
                        if(data != null) {
                            self.priceReplyInfo = data;
                            if(data.goodsFlag) {
                                self.forGoods = true;
                            }
                            if(data.servcFlag) {
                                self.forServc = true;
                            }
                        }
                        self.getTradeRuleInfo();
                        lastMsgBoxDlg.close();
                    } else {
                        lastMsgBoxDlg.close();
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTradeRuleInfo: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.id;
                priceApi.getPriceReplyTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let priceReplyTermList = result.data;
                        if(priceReplyTermList != null && priceReplyTermList.length > 0) {
                            self.comparedTradeRuleList = priceReplyTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },
            adoptedPrice: function () {
                let self = this;
                let id = this.$route.query.id;
                self.$confirm("确认采纳此报价信息？", "提示", {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let lastMsgBoxDlg = MsgBox.loading();
                    priceApi.adoptPriceInqryVoucher(id, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success("已采纳");
                            self.goBackPage();
                            lastMsgBoxDlg.close();
                        } else {
                            lastMsgBoxDlg.close();
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },

            goBackPage: function () {
                this.$router.push({
                    path: SwbPriceInpryList.path
                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceReplyInfo.vue